import { provideHttpClient, withFetch } from '@angular/common/http';
import {
  ApplicationConfig,
  provideZonelessChangeDetection
} from '@angular/core';
import {
  provideClientHydration,
  withEventReplay,
  withHttpTransferCacheOptions
} from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  withInMemoryScrolling,
  withPreloading
} from '@angular/router';
import { quicklinkProviders, QuicklinkStrategy } from 'ngx-quicklink';
import { routes } from '../app.routes';
import { envKeys } from '../environment.providers';

// Firebase initialization handled by custom tokens in @vaki/shared/util/environment
// (FIREBASE_APP, AUTH, FIRESTORE, FUNCTIONS, STORAGE with providedIn: 'root')

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideClientHydration(
      withEventReplay(),
      withHttpTransferCacheOptions({
        includePostRequests: true
      })
    ),
    provideHttpClient(withFetch()),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled'
      }),
      // Preload routes when links become visible in the viewport
      withPreloading(QuicklinkStrategy)
    ),
    // Quicklink providers for intelligent route preloading
    quicklinkProviders,
    provideAnimationsAsync(),
    ...envKeys
  ]
};
